import { styled, Box, BoxProps, selectTheme, media } from '@creditas-ui/react';

export type SubMenuListProps = BoxProps & {
  open: boolean;
};

const SubMenuList = styled(Box)<SubMenuListProps>`
  display: ${(props) => (props.open ? 'block' : 'none')};

  margin-top: 20px;

  ${media.up('5xl')} {
    position: absolute;
    left: 0px;
    top: 80px;
    min-width: 280px;
    margin-top: 0;
    padding: 21px;
    border-bottom-right-radius: 16px;
    border-bottom-left-radius: 16px;
    background-color: ${selectTheme('colors.neutral.0')};
    box-shadow: 0px 10px 12px rgb(0 0 0 / 8%), 0px 12px 12px rgb(0 0 0 / 1%);
  }

  & > * + * {
    margin-top: 12px;

    ${media.up('5xl')} {
      margin-top: 30px;
    }
  }
`;

export { SubMenuList };
